import type {paths} from '@freckle/student-entities/ts/open-api/fancy/generated-client'

export type RlStandardSetT =
  paths['/2/students/me']['get']['responses']['200']['content']['application/json']['elaStandardSet'] & {
    // Plural versions of the labels from API where we simply add an 's'
    domainsLabel: string
    standardsLabel: string
    // The backend doesn't provide skills labels at all, but probably should. These are faked for now:
    skillLabel: string
    skillsLabel: string
  }

export const parseAttrs = (
  attrs: paths['/2/students/me']['get']['responses']['200']['content']['application/json']['elaStandardSet']
): RlStandardSetT => {
  return {
    ...attrs,
    domainsLabel: `${attrs.domainLabel}s`,
    standardsLabel: `${attrs.standardLabel}s`,
    skillLabel: 'skill',
    skillsLabel: 'skills'
  }
}
